import { appLocale } from './setupConfig';
import enCountries from 'i18n-iso-countries/langs/en.json';
import frCountries from 'i18n-iso-countries/langs/fr.json';

/**
 * Export language support for countries based on language code
 */
function langSupport() {
  switch (appLocale.code) {
    case 'en':
      return enCountries;
    case 'fr':
      return frCountries;
    default:
      return enCountries;
  }
}

export default langSupport();
